<template>
  <!-- 经典案例 start -->
      <div class="case-menu">
        <ul class="case-menu-1" v-if="IsPC()">
          <li :class="'case-li-'+index" v-for="(item,index) in newCaseList" :key="index">
            <div class="case-li-in">
              <div class="case-t-1">
                <p>{{item.area}}</p>
                <p>{{item.time}}</p>
              </div>
              <div class="case-t-2">
                <span>{{item.subTitle}}</span>
              </div>
              <div class="case-t-3">
                <div class="fourline">{{item.content}}</div>
                <div class="case-t-btn">
                  <span @click.stop="goCasePage(index)">查看详情</span>
                </div>
              </div>
            </div>
          </li>
          <li class="case-li-5">
            <div @click.stop="goCasePage('more')">查看更多案例 <i class="el-icon-d-arrow-right"></i></div>
          </li>
        </ul>
        <ul class="case-menu-2" v-else>
          <li @click="goCaseIndex" class="case-li-1"><span>全部</span></li>
          <li @click.stop="goCasePage(index)" v-for="(item,index) in newCaseList" :key="index">{{item.subTitle}}</li>
        </ul>
      </div>
      <!-- 经典案例 end -->
</template>

<script>
import { caseList } from "@/views/case/caseInfo";
import { IsPC } from "@/utils"
export default {
  data(){
    return{
      caseCount: 5,
      caseList,
    }
  },
  computed:{
    newCaseList (){
      let list = this.caseList.slice(0, this.caseCount)
      // console.log(list);
      
      return list
    }
  },
  methods: {
    IsPC,
    goCaseIndex () {
      this.$router.push({
        path: '/case'
      })
    },
    goCasePage (index){
      if(!this.IsPC()){
        this.$emit('closeMenu', 2)
      }
      if(index === 'more'){
        this.$router.push({
          path: '/case'
        })
      } else{
        this.$router.push({
          path: '/caseDetails',
          query: {
            id: index
          }}
        )
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/menu.scss';
</style>


// WEBPACK FOOTER //
// src/views/components/menu-case.vue